import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allResourcesPermissions: [],
  resourcePermission: {},
  resourcePermissionsBySite: [],
  resourcePermissionsByRole: [],
  resourcePermissionsByResource: [],
  newResourcePermission: {},
  updatedResourcePermission: {},
  deletedResourcePermissions: {},
  error: null,
};

const resourcePermissionSlice = createSlice({
  name: 'resourcePermission',
  initialState,
  reducers: {
    setReducerError: (state, action) => {
      state.error = action.error;
    },
    setAllResourcesPermissions: (state, action) => {
      state.allResourcesPermissions = action.payload;
      state.error = null;
    },
    setResourcePermission: (state, action) => {
      state.resourcePermission = action.payload;
      state.error = null;
    },
    setResourcePermissionsBySite: (state, action) => {
      state.resourcePermissionsBySite = action.payload;
      state.error = null;
    },
    setResourcePermissionsByResource: (state, action) => {
      state.resourcePermissionsByResource = action.payload;
      state.error = null;
    },
    setResourcePermissionsByRole: (state, action) => {
      state.resourcePermissionsByRole = action.payload;
      state.error = null;
    },
    setNewResourcePermission: (state, action) => {
      state.newResourcePermission = action.payload;
      state.error = null;
    },
    setUpdatedResourcePermission: (state, action) => {
      state.updatedResourcePermission = action.payload;
      state.error = null;
    },
    setDeletedResourcePermissions: (state, action) => {
      state.deletedResourcePermissions = action.payload;
      state.error = null;
    },
    setResetResourcePermission: () => {
      return initialState;
    },
  },
});

export const {
  setReducerError,
  setAllResourcesPermissions,
  setResourcePermission,
  setResourcePermissionsBySite,
  setResourcePermissionsByResource,
  setResourcePermissionsByRole,
  setNewResourcePermission,
  setUpdatedResourcePermission,
  setDeletedResourcePermissions,
  setResetResourcePermission,
} = resourcePermissionSlice.actions;

export default resourcePermissionSlice.reducer;
